import { RadioOption } from 'components/RadioGroupField/RadioGroupField.component';
import { DocumentInfoType } from 'models/Listing';
import { getSortComparator } from 'utils';

const sortDocumentsByName = (documents: DocumentInfoType[] = []) =>
  [...documents].sort((a, b) =>
    getSortComparator(a.name.toLowerCase(), b.name.toLowerCase()),
  );

export const getDocumentOptions = (
  documents?: DocumentInfoType[],
): RadioOption<string>[] =>
  sortDocumentsByName(documents).map(({ fileId, name }) => ({
    label: name,
    value: fileId,
  }));
